import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { supabase } from '../../../lib/supabase';
import { useNavigate } from 'react-router-dom';

const LandingFooter = () => {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubscribe = async (e) => {
    e?.preventDefault();
    setError('');

    if (!email?.trim()) {
      setError('Vennligst skriv inn e-postadressen din.');
      return;
    }
    if (!consent) {
      setError('Du må samtykke til å motta nyhetsbrev.');
      return;
    }

    setLoading(true);
    try {
      const { error: supabaseError } = await supabase?.from('contact_optins')?.insert({
          email: email?.trim(),
          optin_email: true,
          source: 'footer_newsletter'
        });

      if (supabaseError) {
        if (supabaseError?.code === '23505') {
          setError('Denne e-postadressen er allerede registrert.');
        } else {
          setError('Noe gikk galt. Prøv igjen senere.');
        }
      } else {
        setSuccess(true);
        setEmail('');
        setConsent(false);
        navigate('/newsletter-subscription-thank-you-page');
      }
    } catch (err) {
      setError('Noe gikk galt. Prøv igjen senere.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer
      style={{
        background: '#050A12',
        position: 'relative',
        overflow: 'hidden'
      }}>
      {/* Full-width landscape image strip */}
      <div
        style={{
          position: 'relative',
          height: '280px',
          overflow: 'hidden'
        }}>
        
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_110bb0368-1772187879265.png"
          alt="Panoramic aerial view of Norwegian fjord landscape with winding roads and snow-capped mountains at golden hour"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 40%',
            filter: 'brightness(0.4) contrast(1.1) saturate(0.7)'
          }} />
        
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, transparent 0%, #050A12 100%)'
          }} />
        
        {/* Centered tagline over image */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '12px'
          }}>
          
          <div
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.5rem, 4vw, 3rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.04em',
              textAlign: 'center'
            }}>
            
            Norges veier. Din kontroll.
          </div>
          <div
            style={{
              fontFamily: 'Lora, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(0.875rem, 1.5vw, 1.125rem)',
              color: 'rgba(238,240,242,0.5)',
              textAlign: 'center'
            }}>
            
            Fra Nordkapp til Lindesnes — NordPass er med deg hele veien.
          </div>
        </div>
      </div>
      {/* Footer content */}
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '80px 5% 60px' }}>

        {/* Newsletter subscription form */}
        <div
          className="newsletter-grid"
          style={{
            marginBottom: '60px',
            paddingBottom: '60px',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '48px',
            alignItems: 'center'
          }}>
          
          {/* Left: heading + description */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: 'clamp(1.25rem, 2.5vw, 1.875rem)',
                fontWeight: 800,
                color: '#EEF0F2',
                letterSpacing: '-0.03em',
                marginBottom: '12px',
                lineHeight: 1.15
              }}>
              Hold deg oppdatert
            </div>
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.9375rem',
                color: 'rgba(138,149,163,0.75)',
                lineHeight: 1.65,
                maxWidth: '420px'
              }}>
              Få de siste nyhetene om norske veier, bompriser og tjenesteoppdateringer direkte i innboksen din.
            </p>
          </div>

          {/* Right: form */}
          <div>
            {success ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '20px 24px',
                  background: 'rgba(59,111,212,0.1)',
                  border: '1px solid rgba(59,111,212,0.3)'
                }}>
                <Icon name="CheckCircle" size={20} color="#3B6FD4" />
                <div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2', marginBottom: '2px' }}>
                    Takk for påmeldingen!
                  </div>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.7)' }}>
                    Du vil snart motta nyheter fra NordPass.
                  </div>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubscribe}>
                {/* Email input + button row */}
                <div style={{ display: 'flex', gap: '0', marginBottom: '14px' }}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e?.target?.value)}
                    placeholder="din@epost.no"
                    style={{
                      flex: 1,
                      padding: '13px 16px',
                      background: 'rgba(255,255,255,0.04)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRight: 'none',
                      color: '#EEF0F2',
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '0.9375rem',
                      outline: 'none',
                      transition: 'border-color 150ms ease'
                    }}
                    onFocus={(e) => { e.target.style.borderColor = 'rgba(59,111,212,0.5)'; }}
                    onBlur={(e) => { e.target.style.borderColor = 'rgba(255,255,255,0.1)'; }}
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      padding: '13px 24px',
                      background: loading ? 'rgba(59,111,212,0.5)' : '#E8630A',
                      border: 'none',
                      color: '#EEF0F2',
                      fontFamily: 'Syne, sans-serif',
                      fontSize: '0.875rem',
                      fontWeight: 700,
                      letterSpacing: '0.04em',
                      textTransform: 'uppercase',
                      cursor: loading ? 'not-allowed' : 'pointer',
                      transition: 'background 150ms ease',
                      whiteSpace: 'nowrap',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                    onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = '#CF5508'; }}
                    onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = '#E8630A'; }}>
                    {loading ? (
                      <>
                        <Icon name="Loader" size={14} color="#EEF0F2" />
                        Sender...
                      </>
                    ) : (
                      'Abonner'
                    )}
                  </button>
                </div>

                {/* GDPR consent checkbox */}
                <label
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    cursor: 'pointer',
                    marginBottom: error ? '10px' : '0'
                  }}>
                  <div
                    onClick={() => setConsent(!consent)}
                    style={{
                      width: '16px',
                      height: '16px',
                      minWidth: '16px',
                      marginTop: '2px',
                      background: consent ? '#3B6FD4' : 'rgba(255,255,255,0.04)',
                      border: `1px solid ${consent ? '#3B6FD4' : 'rgba(255,255,255,0.15)'}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 150ms ease',
                      cursor: 'pointer'
                    }}>
                    {consent && <Icon name="Check" size={10} color="#EEF0F2" />}
                  </div>
                  <span
                    onClick={() => setConsent(!consent)}
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '0.8125rem',
                      color: 'rgba(138,149,163,0.65)',
                      lineHeight: 1.55,
                      userSelect: 'none'
                    }}>
                    Jeg samtykker til å motta nyhetsbrev fra NordPass og godtar{' '}
                    <Link
                      to="/privacy-policy-personvern"
                      onClick={(e) => e?.stopPropagation()}
                      style={{ color: '#3B6FD4', textDecoration: 'none' }}>
                      personvernreglene
                    </Link>.
                  </span>
                </label>

                {/* Error message */}
                {error && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginTop: '10px'
                    }}>
                    <Icon name="AlertCircle" size={13} color="#E8630A" />
                    <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#E8630A' }}>
                      {error}
                    </span>
                  </div>
                )}
              </form>
            )}
          </div>
        </div>

        {/* Main footer grid */}
        <div
          className="footer-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
            gap: '48px',
            marginBottom: '60px',
            paddingBottom: '60px',
            borderBottom: '1px solid rgba(255,255,255,0.06)'
          }}>
          
          {/* Brand column */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '1.5rem',
                fontWeight: 800,
                color: '#EEF0F2',
                letterSpacing: '-0.04em',
                marginBottom: '16px'
              }}>
              NordPass
            </div>
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem',
                color: 'rgba(138,149,163,0.8)',
                lineHeight: 1.7,
                marginBottom: '20px',
                maxWidth: '300px'
              }}>
              Norges ledende plattform for veikart, bomkalkulator og kjøretøyadministrasjon. 
              Designet for norske sjåfører, av norske utviklere.
            </p>

            {/* Contact info */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
              {[
                { icon: 'Mail', text: 'hei@nordpassno.com' },
                { icon: 'Phone', text: '+47 20 94 89 03' },
                { icon: 'MapPin', text: 'Karl Johans gate 1, Oslo' },
                { icon: 'Clock', text: 'Man–Fre 08:00–20:00' }
              ]?.map((item, i) =>
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                  <Icon name={item?.icon} size={13} color="#3B6FD4" style={{ marginTop: '2px', flexShrink: 0 }} />
                  <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.7)', lineHeight: 1.5 }}>{item?.text}</span>
                </div>
              )}
            </div>

            {/* Social media */}
            <div style={{ display: 'flex', gap: '10px' }}>
              {['Twitter', 'Facebook', 'Instagram', 'Linkedin']?.map((social, i) =>
                <a
                  key={i}
                  href="#"
                  style={{
                    width: '34px',
                    height: '34px',
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 200ms ease',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(59,111,212,0.4)'; e.currentTarget.style.background = 'rgba(59,111,212,0.1)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}>
                  <Icon name={social} size={13} color="#8A95A3" />
                </a>
              )}
            </div>
          </div>

          {/* Company column */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: '#EEF0F2',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginBottom: '20px',
                paddingBottom: '12px',
                borderBottom: '1px solid rgba(59,111,212,0.3)'
              }}>
              Selskap
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'Om Oss', path: '/om-oss-about-us' },
                { label: 'Kontakt', path: '/nord-pass-contact-page' },
                { label: 'Karriere', path: '/om-oss-about-us' }
              ]?.map((link, i) =>
                <Link
                  key={i}
                  to={link?.path}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: 'rgba(138,149,163,0.7)',
                    textDecoration: 'none',
                    transition: 'color 150ms ease'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#EEF0F2'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(138,149,163,0.7)'; }}>
                  {link?.label}
                </Link>
              )}
            </div>
          </div>

          {/* Legal column */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: '#EEF0F2',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginBottom: '20px',
                paddingBottom: '12px',
                borderBottom: '1px solid rgba(59,111,212,0.3)'
              }}>
              Juridisk
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'Personvern', path: '/privacy-policy-personvern' },
                { label: 'Vilkår & Betingelser', path: '/terms-conditions-vilk-r-betingelser' },
                { label: 'SMS Opt-in Vilkår', path: '/sms-optin-vilkar' }
              ]?.map((link, i) =>
                <Link
                  key={i}
                  to={link?.path}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: 'rgba(138,149,163,0.7)',
                    textDecoration: 'none',
                    transition: 'color 150ms ease'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#EEF0F2'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(138,149,163,0.7)'; }}>
                  {link?.label}
                </Link>
              )}
            </div>
          </div>

          {/* Resources column */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: '#EEF0F2',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginBottom: '20px',
                paddingBottom: '12px',
                borderBottom: '1px solid rgba(59,111,212,0.3)'
              }}>
              Ressurser
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'Blogg', path: '/blog-news-landing-page-blogg-nyheter' },
                { label: 'FAQ', path: '/faq' },
                { label: 'Tjenester', path: '/tjenester-services' }
              ]?.map((link, i) =>
                <Link
                  key={i}
                  to={link?.path}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '0.875rem',
                    color: 'rgba(138,149,163,0.7)',
                    textDecoration: 'none',
                    transition: 'color 150ms ease'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#EEF0F2'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(138,149,163,0.7)'; }}>
                  {link?.label}
                </Link>
              )}
            </div>
          </div>

          {/* Abonnement column */}
          <div>
            <div
              style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 700,
                color: '#EEF0F2',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginBottom: '20px',
                paddingBottom: '12px',
                borderBottom: '1px solid rgba(59,111,212,0.3)'
              }}>
              Abonnement
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                { label: 'NordPass Gratis', price: '0 kr/mnd' },
                { label: 'NordPass Normal', price: '149 kr/mnd' },
                { label: 'NordPass Premium', price: '299 kr/mnd' }
              ]?.map((plan, i) =>
                <div key={i}>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: 'rgba(138,149,163,0.7)' }}>{plan?.label}</div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: '#3B6FD4', marginTop: '2px' }}>{plan?.price}</div>
                </div>
              )}
              <Link
                to="/newsletter-preferences-management-page"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.875rem',
                  color: 'rgba(138,149,163,0.7)',
                  textDecoration: 'none',
                  transition: 'color 150ms ease',
                  marginTop: '8px',
                  display: 'block'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#EEF0F2'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(138,149,163,0.7)'; }}
              >
                Nyhetsbrevinnstillinger
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px'
          }}>
          
          <div
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: 'rgba(138,149,163,0.4)',
              letterSpacing: '0.06em'
            }}>
            © 2022 NordPass AS — Norges veier, din kontroll.
          </div>
          <div style={{ display: 'flex', gap: '24px' }}>
            {[
              { label: 'Personvern', path: '/privacy-policy-personvern' },
              { label: 'Vilkår', path: '/terms-conditions-vilk-r-betingelser' },
              { label: 'Cookies', path: '/privacy-policy-personvern#informasjonskapsler' },
              { label: 'GDPR', path: '/privacy-policy-personvern#rettigheter' }
            ]?.map((item, i) =>
              <Link
                key={i}
                to={item?.path}
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.75rem',
                  color: 'rgba(138,149,163,0.4)',
                  textDecoration: 'none',
                  transition: 'color 150ms ease'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#8A95A3'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(138,149,163,0.4)'; }}>
                {item?.label}
              </Link>
            )}
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 767px) {
          .newsletter-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
          .footer-grid > div:first-child { grid-column: 1 / -1; }
        }
        @media (max-width: 480px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
};

export default LandingFooter;